export default __webpack_public_path__ + "static/media/icon-sms-code-error.76f839ff.svg";